<template>
  <div class="action-center">
    <Submissions :defaultFilter="'pending'" />
    <br />
    <GiftSubBatches v-if="isPremium" :filter="'pending'" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Submissions from './Submissions.vue'
import GiftSubBatches from './GiftSubBatches.vue'

export default {
  name: 'ActionCenter',
  components: {
    Submissions,
    GiftSubBatches
  },
  computed: {
    ...mapGetters(['isPremium'])
  }
}
</script>
